<template>
	<!-- 业绩材料 -->
	<div class="quarter-card">
		<h4>{{ $t('enterprise.earnings-library') }}</h4>
		<!-- 业绩公告 -->
		<div class="material-list" @click="itemHandler('announcementLink')">
			<div class="material-title">{{ quarterDetails.announcementTitle }}</div>
			<div>
				<span class="material-type material-type-announcement">{{
					$t('enterprise.results-announcement')
				}}</span>
			</div>
		</div>
		<!-- 业绩摘要 -->
		<div v-if="quarterDetails.roundupTitle" class="material-list" @click="itemHandler('roundupLink')">
			<div class="material-title">{{ quarterDetails.roundupTitle }}</div>
			<div>
				<span class="material-type material-type-roundup">{{ $t('enterprise.results-summary') }}</span>
			</div>
		</div>
		<!-- 演示材料 -->
		<div v-if="quarterDetails.showTitle" class="material-list" @click="itemHandler('showLink')">
			<div class="material-title">{{ quarterDetails.showTitle }}</div>
			<div>
				<span class="material-type material-type-show">{{ $t('enterprise.earnings-library') }}</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const props = defineProps({
	quarterDetails: {
		type: Object,
		required: true
	}
});

const { viewModule } = useModuleNavigation();
const itemHandler = type => {
	const { announcementLink, roundupLink, showLink, id } = props.quarterDetails;
	if (type === 'announcementLink') {
		viewModule('quarterly_performance_announcement', { comeinLink: announcementLink, id });
	}
	if (type === 'roundupLink') {
		viewModule('quarterly_performance_summary', { comeinLink: roundupLink, id });
	}
	if (type === 'showLink') {
		viewModule('quarterly_performance_custom', { comeinLink: showLink, id });
	}
};
</script>

<style lang="less" scoped>
.quarter-card {
	margin-bottom: 12px;
	padding: 16px;
	border-radius: 6px;
	background: #fff;
	h4 {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: var(--t-emphasis-color, #1d2129);

		font-size: 16px;
		font-weight: 500;
		line-height: 24px; /* 150% */
	}

	.material-list {
		padding: 16px 0 0;
		&:not(:last-child) {
			padding: 16px 0;
			border-bottom: 1px solid #f2f3f5;
		}
		.material-title {
			color: var(---__black_text, #12121a);
			font-size: 15px;
			font-weight: 500;
			line-height: 24px; /* 160% */
		}
		.material-type {
			display: inline-flex;
			height: 14px;
			padding: 0 4px;
			border-radius: 1px;
			background: #ebeffc;
			color: #3964e5;

			font-size: 10px;

			font-weight: 400;
			line-height: 14px;

			&-announcement {
				color: #f07146;
				background: #fdf1ec;
			}
			&-roundup {
				color: #8f39e5;
				background: #f4ebfc;
			}
		}
	}
}
</style>
